import { render, staticRenderFns } from "./RefundModal.vue?vue&type=template&id=23da74f3&scoped=true"
import script from "./RefundModal.vue?vue&type=script&lang=js"
export * from "./RefundModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23da74f3",
  null
  
)

export default component.exports